import { connect } from 'react-redux';
import { WebSocketIndicatorView } from './WebSocketIndicator.view';
import { RematchContext } from 'models/rematchStore';

const mapState = ({ webSocket: { connected, disconnectionTimestamp, reconnect }, appData }) => ({
    connected,
    disconnectionTimestamp,
    reconnect,
    isWebSocketEnabled: appData.isWebSocketEnabled,
});
const mapDispatch = (dispatch) => ({
    restartWebsocket: () =>
        dispatch({
            type: 'appData/reconfigureSite',
        }),
});

export const WebSocketIndicator = connect(mapState, mapDispatch, undefined, { context: RematchContext })(
    WebSocketIndicatorView
);
